const AdminPanel = () => {  
    return(
        <div>
            
        </div>
            );
}

export default AdminPanel;